import { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

export default function useBlockNavigation() {
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (unsavedChanges) {
                e.preventDefault();
                e.returnValue = ''; // required for chrome
                return true; // Return a truthy value
            }
            return null; // Allow navigation if no conditions met
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [unsavedChanges]);

    const shouldBlockNavigation = ({ currentLocation, nextLocation }) => {
        if (unsavedChanges && nextLocation.pathname !== currentLocation.pathname) {
            return true;
        }
        return null; // Allow navigation
    };

    let blocker = useBlocker(shouldBlockNavigation);

    return {
        proceedNavigation: blocker?.proceed,
        blocked: blocker.state === 'blocked',
        reset: blocker?.reset,
        setUnsavedChanges,
        unsavedChanges
    };
}
